import { useEffect, useState } from "react";
import styles from "./Wishlist.module.scss";
import { WishlistTypes } from "../../../api/types/products.types";
import Loading from "../../../components/common/loading/Loading";
import ProductCard from "../../../components/common/product-card/ProductCard";
import ProductsService from "../../../api/services/products.service";
import { useCurrencies } from "../../../context/CurrenciesContext";
import TitleUpdater from "../../../components/common/title/TitleUpdater";
import { useAuth } from "../../../context/AuthContext";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../context/LanguageContext";
import star from "../../../assets/images/store/star.png";

const Wishlist = () => {
  const [products, setProducts] = useState<WishlistTypes[]>([]);
  const [loading, setLoading] = useState(false);
  const { currencyId } = useCurrencies();
  const { isLoggedIn } = useAuth();
  const { t } = useTranslation("translation");
  const { currentLanguage } = useLanguage();

  useEffect(() => {
    if (!currencyId) {
      return;
    }
    setLoading(true);
    const getData = async () => {
      try {
        const res = await ProductsService.getAllWishlist(Number(currencyId));
        setProducts(res.data);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [currencyId]);

  const getLocalizedName = (product: WishlistTypes) => {
    switch (currentLanguage) {
      case "az":
        return product?.product?.name_az || product?.product?.name_en;
      case "de":
        return product?.product?.name_de || product?.product?.name_en;
      case "es":
        return product?.product?.name_es || product?.product?.name_en;
      case "en":
      default:
        return product?.product?.name_en;
    }
  };

  if (isLoggedIn && loading) {
    return <Loading />;
  }

  return (
    <section className={styles.products}>
      <TitleUpdater title={t("wishlist")} />
      {products.length === 0 && (
        <div className={styles.no_data}>
          <img src={star} alt="No data" className={styles.no_data_image} />
          <h3 className={styles.no_data_title}>{t("wishlist_empty")}</h3>
          <p className={styles.no_data_description}>
            {t("no_wishlist_description")}
          </p>
        </div>
      )}
      <div className="container">
        <div className={styles.products_list}>
          {products.map((p, i) => (
            <ProductCard
              id={p.product.id}
              key={i}
              title={getLocalizedName(p)}
              currency={p.product.currency_name}
              price={p.product.price?.toString()}
              discount_percent={p.product?.discount_percent?.toString()}
              discount_price={p.product.discount_price?.toString()}
              image={p.product.images[0] ? p.product.images[0]?.image : ""}
              stock_quantity={p.product.stock_quantity}
              wishlist={p.product.is_wish}
              onRemove={() =>
                setProducts((prev) =>
                  prev.filter((item) => item.product.id !== p.product.id),
                )
              }
              images={p?.product?.images}
              attributes={p?.product?.attributes}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Wishlist;
